/** @deprecated - there should be export from module itself eg. TRANSLATION_NAMESPACE from apps/tracking */
export enum TranslationNamespace {
  SCREENS = 'screens',
}
